import component from './request-password-reset';

export default {
	path : '/',
	name : 'request-password-reset',
	component,
};
